import React from 'react'
import { CompanyAttributesAccordion } from './CompanyAttributesAccordion'
import { DealsOverviewAccordion } from './DealsOverviewAccordion'
import { CompanyTopCard } from './CompanyTopCard'
import { EventHistoryAccordion } from './EventHistory'
import { TableTypeSlug, CompanyTypeSlug } from 'models/companies'

interface CompanyContentSectionsProps {
  chainProxyId: number
  entityID?: number
  doorProxyId?: number
  companyName: string
  websiteAddress: string
  companyTypeSlug: CompanyTypeSlug
  tableTypeSlug: TableTypeSlug
  isUserCreated?: boolean
  isDoorPage?: boolean
}

/**
 * Reusable content sections for all company and door pages.
 * Includes: CompanyTopCard, CompanyAttributesAccordion, DealsOverviewAccordion, and EventHistoryAccordion.
 *
 * This component provides a consistent layout across all new company page types
 * (chains, universities, hospitals, K12 districts, nursing homes, lodging, convenience stores, unmatched companies, and their door pages).
 */
export function CompanyContentSections({
  chainProxyId,
  entityID,
  doorProxyId,
  companyName,
  websiteAddress,
  companyTypeSlug,
  tableTypeSlug,
  isUserCreated = false,
  isDoorPage = false,
}: CompanyContentSectionsProps) {
  // Only pass chainID for restaurant chains, not for other company types
  const isRestaurantChain = companyTypeSlug === 'restaurants-bars'

  return (
    <>
      {/* Top Card with Actions and Quick Note */}
      <CompanyTopCard
        chainProxyId={chainProxyId}
        doorProxyId={doorProxyId}
        chainID={isRestaurantChain ? entityID : undefined}
        companyName={companyName}
        websiteAddress={websiteAddress}
        companyTypeSlug={companyTypeSlug}
        tableTypeSlug={tableTypeSlug}
        isUserCreated={isUserCreated}
        isDoorPage={isDoorPage}
      />

      {/* Company Attributes Accordion */}
      <CompanyAttributesAccordion
        chainProxyId={chainProxyId}
        doorProxyId={doorProxyId}
        companyType={companyTypeSlug}
      />

      {/* Deals Overview Accordion */}
      <DealsOverviewAccordion
        chainProxyId={chainProxyId}
        doorProxyId={doorProxyId}
        tableTypeSlug={tableTypeSlug}
        companyTypeSlug={companyTypeSlug}
      />

      {/* Event History Accordion */}
      <EventHistoryAccordion
        chainProxyId={chainProxyId}
        doorProxyId={doorProxyId}
        companyType={companyTypeSlug}
      />
    </>
  )
}
